import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import image from '../../Images/portfolio.png';
import './banner.css';
import { FaGithub, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import resumeDownload from '../../pdfFiles/resumeSrayo.pdf';
import Typewriter from 'typewriter-effect';


const Banner = () => {

    return (
        <div className='backGroundSet' id='banner'>

            <div className='container d-flex flex-column flex-md-row justify-content-between align-items-center mt-5 setAlign'>
                <div className='text-warning' data-aos="fade-right" data-aos-duration="2000">
                    <h1>Hello</h1>
                    <h3 >This is Md. Saimon Sikder Srayo</h3>
                    <h4>
                        I am a
                        <Typewriter
                            options={{
                                autoStart: true,
                                loop: true,
                                delay: 40,
                                strings: [
                                    "Web Developer",
                                    "Full Stack Developer",
                                    "Front End Developer",
                                    "React Developer",
                                    "MERN Stack Developer"
                                ]
                            }}
                        />
                    </h4>
                    {/* <h4>I'm a full-stack web developer</h4> */}
                    <div className='mt-4 mb-3'>
                        <a href="https://github.com/srayo16" target='_blank' rel="noreferrer" ><FaGithub className='me-3 fs-2 text-info icon-hovers'></FaGithub></a>
                        <a href="https://www.linkedin.com/in/srayo-sikder/" target='_blank' rel="noreferrer" ><FaLinkedin className='me-3 fs-2 text-info icon-hovers'></FaLinkedin></a>
                        <a href="mailto:srayosikder@gmail.com" target='_blank' rel="noreferrer"><FiMail className='me-3 fs-2 text-dark rounded bg-info icon-hovers'></FiMail></a>
                        <a href="https://www.facebook.com/profile.php?id=100009355720684" target='_blank' rel="noreferrer" ><FaFacebook className='me-3 fs-2 text-info icon-hovers'></FaFacebook></a>
                    </div>

                    <a href="mailto:srayosikder@gmail.com" target='_blank' rel="noreferrer">    <Button variant="warning" className='me-3 mt-3 btn-glow'>Hire me</Button></a>

                    <a href={resumeDownload} target='_blank' rel="noreferrer" download={true}><Button variant="warning" className='mt-3 btn-glow'>Download resume</Button></a>

                </div>
                <div data-aos="fade-left" data-aos-duration="2000">
                    <img src={image} className='img-fluid handleImgWidthBanner' width={500} alt="me" />
                </div>
            </div>
        </div>
    );
};

export default Banner;